import { create } from "zustand";

export type ExtendedProfile = {
  uei: string;
  last_updated_date: string | null;
  capabilities_statement_link: string | null;
  current_principals: string | null;
  non_fed_govt_certifications: string | null;
  capabilities_narrative: string | null;
  special_equipment: string | null;
  business_type_percentages: string | null;
  bonding_levels: string | null;
  keywords: string | null;
  quality_assurance_standards: string | null;
  exporter_status: string | null;
  export_business_activities: string | null;
  exporting_to: string | null;
  desired_export_business_relationship: string | null;
  export_objectives_description: string | null;
  additional_website: string | null;
  deleted_at: string | null;
  created_at: string | null;
  display_phone: boolean | null;
  display_email: boolean | null;
  display_fax: boolean | null;
  display_address: boolean | null;
  participation_agreement: {
    certifier_name: string;
    date: string;
  } | null;
  size_determination: SizeDetermination | null;
};

export interface PerformanceHistoryData {
  perf_history_seq: number;
  name: string;
  contract: string;
  contract_start_date: string;
  contract_end_date: string;
  value: string;
  contract_contact: string;
  contract_contact_phone: string;
  uei: string;
  last_updated_date: string;
  created_at: string;
  deleted_at: null;
}

export type SizeDetermination = {
  revenue: string;
  employees: string;
  barrels: string;
  megawatt: string;
  assets: string;
  determinationDate: string;
  determinationReason: string;
};

export type EditedProfileData = {
  extendedProfile: ExtendedProfile;
};

type ProfileEditState = {
  extendedProfile: ExtendedProfile | null;
  setExtendedProfile: (profile: ExtendedProfile) => void;
};

export const useProfileEditStore = create<ProfileEditState>((set) => ({
  extendedProfile: null,

  setExtendedProfile: (_profile: ExtendedProfile) =>
    set({ extendedProfile: _profile }),
}));
